import { ComponentRef, Directive, ElementRef, HostListener, Input, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { NpTooltip } from './tooltip.component';

const OFFSET = 4;

/**
* Tooltipæç¤ºææ¬
* 
* <example-url>https://stackblitz.com/edit/np-tooltip-sample?embed=1&file=src/app/app.component.html</example-url>
*/
@Directive({ selector: '[npTooltip]' })
export class NpTooltipDirective implements OnInit {

    /**æ¾ç¤ºæç¤ºææ¬ */
    @Input('npTooltip') text = '';
    /**æ¯æèªå®ä¹æ¨¡æ¿ng-templateå±ç¤ºæç¤ºææ¬ */
    @Input() template: TemplateRef<any>;
    /**æ¯æä¸ãå³ãä¸ãå·¦ãä¸å·¦ãä¸å³ãä¸å·¦ãä¸å³8ä¸ªæ¹åå±ç¤ºæç¤ºææ¬ï¼é»è®¤å±ç¤ºä¸æ¹æç¤ºææ¬ */
    @Input() position: NpTooltipPosition = 'top';
    /**æç¤ºææ¬èæ¯è² */
    @Input() bgColor: string = 'rgba(73, 89, 106, .7)';
    /**æç¤ºææ¬æ°´å¹³æ¹åXè½´ä½ç§» */
    @Input() offsetX: number = null;
    /**æç¤ºææ¬åç´æ¹åYè½´ä½ç§» */
    @Input() offsetY: number = null;
    /**æ¯å¦å±ç¤ºæç¤ºææ¬æåç®­å¤´ï¼é»è®¤å±ç¤º */
    @Input() showArrow: boolean = true;
    /**è§¦åæ¹å¼ï¼é»è®¤ä¸ºé¼ æ hover */
    @Input() trigger: 'hover' | 'click' = 'hover';

    private overlayRef: OverlayRef;
    private withPositions: any = {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetX: 0,
        offsetY: -2 * OFFSET
    };
    private delayTimer;

    constructor(private overlay: Overlay,
        private overlayPositionBuilder: OverlayPositionBuilder,
        private elementRef: ElementRef,
        public renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.initWithPositions();

        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([this.withPositions]);

        this.overlayRef = this.overlay.create({ positionStrategy, hasBackdrop: this.trigger === 'click' });
        this.overlayRef.backdropClick().subscribe(res => {
            this.hide();
        });
    }

    ngAfterViewInit() {
        let overlayElement;
        if (this.trigger === 'hover') {
            this.renderer.listen(this.elementRef.nativeElement, 'mouseenter', () => this.delayEnterLeave(true, true, 0.15));
            this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', () => {
                this.delayEnterLeave(true, false, 0.1);
                if (this.overlayRef && !overlayElement) { // NOTE: we bind events under "mouseleave" due to the overlayRef is only created after the overlay was completely shown up
                    overlayElement = this.overlayRef.overlayElement;
                    this.renderer.listen(overlayElement, 'mouseenter', () => this.delayEnterLeave(false, true));
                    this.renderer.listen(overlayElement, 'mouseleave', () => this.delayEnterLeave(false, false));
                }
            });
        } else if (this.trigger === 'click') {
            this.renderer.listen(this.elementRef.nativeElement, 'click', (e) => {
                e.preventDefault();
                this.show();
            });
        }
    }

    private initWithPositions() {
        switch (this.position) {
            case 'top':
                this.withPositions = {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'bottom',
                    offsetX: this.offsetX === null ? 0 : this.offsetX,
                    offsetY: this.offsetY === null ? -2 * OFFSET : this.offsetY
                };
                break;
            case 'right':
                this.withPositions = {
                    originX: 'end',
                    originY: 'center',
                    overlayX: 'start',
                    overlayY: 'center',
                    offsetX: this.offsetX === null ? 2 * OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? 0 : this.offsetY
                };
                break;
            case 'bottom':
                this.withPositions = {
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top',
                    offsetX: this.offsetX === null ? 0 : this.offsetX,
                    offsetY: this.offsetY === null ? 2 * OFFSET : this.offsetY
                };
                break;
            case 'left':
                this.withPositions = {
                    originX: 'start',
                    originY: 'center',
                    overlayX: 'end',
                    overlayY: 'center',
                    offsetX: this.offsetX === null ? -2 * OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? 0 : this.offsetY
                };
                break;
            case 'topLeft':
                this.withPositions = {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom',
                    offsetX: this.offsetX === null ? OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? -2 * OFFSET : this.offsetY
                };
                break;
            case 'topRight':
                this.withPositions = {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'bottom',
                    offsetX: this.offsetX === null ? -OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? -2 * OFFSET : this.offsetY
                };
                break;
            case 'bottomLeft':
                this.withPositions = {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                    offsetX: this.offsetX === null ? OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? 2 * OFFSET : this.offsetY
                };
                break;
            case 'bottomRight':
                this.withPositions = {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top',
                    offsetX: this.offsetX === null ? -OFFSET : this.offsetX,
                    offsetY: this.offsetY === null ? 2 * OFFSET : this.offsetY
                };
                break;
            default:
                break;
        }

        if (this.position === 'top') {
            this.elementRef.nativeElement.classList.add('arrow-bottom');
        }
    }

    private buildArrow() {
        if (!this.overlayRef || !this.overlayRef.hostElement) {
            return;
        }

        let arrowPosition: string;
        switch (this.position) {
            case 'top':
                arrowPosition = 'arrow-bottom'
                break;
            case 'right':
                arrowPosition = 'arrow-left'
                break;
            case 'bottom':
                arrowPosition = 'arrow-top'
                break;
            case 'left':
                arrowPosition = 'arrow-right'
                break;
            case 'topLeft':
                arrowPosition = 'arrow-bottomRight'
                break;
            case 'topRight':
                arrowPosition = 'arrow-bottomLeft'
                break;
            case 'bottomLeft':
                arrowPosition = 'arrow-topRight'
                break;
            case 'bottomRight':
                arrowPosition = 'arrow-topLeft'
                break;

            default:
                break;
        }
        let tooltipTag = this.overlayRef.hostElement.getElementsByTagName('np-tooltip')[0];
        if (tooltipTag) {
            tooltipTag.classList.add(arrowPosition);
        }
    }

    private delayEnterLeave(isOrigin: boolean, isEnter: boolean, delay: number = -1): void {
        if (this.delayTimer) { // Clear timer during the delay time
            window.clearTimeout(this.delayTimer);
            this.delayTimer = null;
        } else if (delay > 0) {
            this.delayTimer = window.setTimeout(() => {
                this.delayTimer = null;
                isEnter ? this.show() : this.hide();
            }, delay * 1000);
        } else {
            isEnter && isOrigin ? this.show() : this.hide(); // [Compatible] The "isOrigin" is used due to the tooltip will not hide immediately (may caused by the fade-out animation)
        }
    }

    show() {
        if (this.overlayRef.hasAttached()) {
            return;
        }

        const tooltipRef: ComponentRef<NpTooltip>
            = this.overlayRef.attach(new ComponentPortal(NpTooltip));

        if (this.text) {
            tooltipRef.instance.text = this.text;
        }

        if (this.template) {
            tooltipRef.instance.template = this.template;
        }

        tooltipRef.instance.bgColor = this.bgColor;

        if (this.showArrow) {
            this.buildArrow();
        }
    }

    hide() {
        if (this.overlayRef.hasAttached) {
            this.overlayRef.detach();
        }
    }
}

export type NpTooltipPosition = 'top' | 'right' | 'bottom' | 'left' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';